export default __webpack_public_path__ + "assets/bc354cc8e77a8a55c0ff67eeb78b2625.svg";